document.addEventListener(
  "DOMContentLoaded",
  () => {

    /* ==========================
       DESKTOP INFINITE MARQUEE
    ========================== */

    const tracks =
      document.querySelectorAll(
        ".testimonial-marquee__track"
      );

    tracks.forEach(
      (track) => {

        const cards =
          track.querySelectorAll(
            ".testimonial-marquee__card"
          );

        if (
          cards.length < 2
        ) return;

        cards.forEach(
          (card) => {

            const clone =
              card.cloneNode(true);

            clone.removeAttribute(
              "id"
            );

            track.appendChild(
              clone
            );

          }
        );

      }
    );

    /* ==========================
       MOBILE AUTO SCROLL
    ========================== */

    const mobileTrack =
      document.querySelector(
        ".testimonial-marquee__mobile"
      );

    if (!mobileTrack) return;

    let isDown = false;
    let startX;
    let scrollLeft;

    mobileTrack.addEventListener(
      "mousedown",
      (e) => {

        isDown = true;

        startX =
          e.pageX -
          mobileTrack.offsetLeft;

        scrollLeft =
          mobileTrack.scrollLeft;

      }
    );

    mobileTrack.addEventListener(
      "mouseleave",
      () => {

        isDown = false;

      }
    );

    mobileTrack.addEventListener(
      "mouseup",
      () => {

        isDown = false;

      }
    );

    mobileTrack.addEventListener(
      "mousemove",
      (e) => {

        if (!isDown) return;

        e.preventDefault();

        const x =
          e.pageX -
          mobileTrack.offsetLeft;

        const walk =
          (x - startX) * 2;

        mobileTrack.scrollLeft =
          scrollLeft - walk;

      }
    );

  }
);